// Lightweight feature flags for the React UI.
//
// Goals:
//   * Default OFF in production builds.
//   * Easy to enable in UAT environments via build-time env var.
//   * Easy to enable for one-off browser sessions via localStorage,
//     so QA / support can toggle without a redeploy.
//
// To enable:
//   * Build/run-time: set `REACT_APP_UAT_MODE=true` in `.env` (or env).
//   * Browser-only:  `localStorage.setItem('uatMode', '1')` then reload.
// To disable for a session: `localStorage.setItem('uatMode', '0')`
// (overrides the build-time env var).

/** True when the app should expose UAT-only affordances. */
export function isUatMode() {
  try {
    const ls = typeof window !== 'undefined' && window.localStorage
      ? window.localStorage.getItem('uatMode')
      : null;
    if (ls === '1' || ls === 'true') {return true;}
    if (ls === '0' || ls === 'false') {return false;}
  } catch (_e) {
    // localStorage may be unavailable (private mode, SSR) — fall through.
  }
  const env = (process.env.REACT_APP_UAT_MODE || '').toLowerCase();
  return env === '1' || env === 'true';
}
